import React from "react";

export const addSizeToImgUrl = (url, size = 700) => {
  if (!url) {
    return "";
  } else if (!size || size !== null) {
    return url.replace("/land/700/", `/land/${size}/`);
  } else {
    return url;
  }
};

export const ColorVariables = (setting) => {
  return `
:root {

--radius-light: ${setting?.data?.light_mode_styles?.theme?.radius?.value};
--box_shadow-light: ${setting?.data?.light_mode_styles?.theme?.box_shadow?.value};
--section_box_shadow-light: ${setting?.data?.light_mode_styles?.theme?.section_box_shadow?.value};

--body_text-light: ${setting?.data?.light_mode_styles?.body?.body_text?.value};
--body_bg_color-light: ${setting?.data?.light_mode_styles?.body?.body_color?.value};
--icons_color-light: ${setting?.data?.light_mode_styles?.body?.icons_color?.value};
--divider_color-light: ${setting?.data?.light_mode_styles?.body?.divider_color?.value};
--button_text-light: ${setting?.data?.light_mode_styles?.body?.button_text?.value};
--button_bg-light: ${setting?.data?.light_mode_styles?.body?.button_background?.value};
--button_text_hover-light: ${setting?.data?.light_mode_styles?.body?.button_text_hover?.value};
--button_background_hover-light: ${setting?.data?.light_mode_styles?.body?.button_background_hover?.value};
--even_row_bg-light: ${setting?.data?.light_mode_styles?.body?.even_row_background?.value};
 
--footer_text-light: ${setting?.data?.light_mode_styles?.footer?.footer_text?.value};
--footer_icons-light: ${setting?.data?.light_mode_styles?.footer?.footer_icons?.value};
--footer_divider-light: ${setting?.data?.light_mode_styles?.footer?.footer_divider?.value};
--footer_bg-light: ${setting?.data?.light_mode_styles?.footer?.footer_background?.value};
--footer_icon_active-light: ${setting?.data?.light_mode_styles?.footer?.footer_icon_active?.value};
--footer_logo_bg-light: ${setting?.data?.light_mode_styles?.footer?.footer_logo_background?.value};
 
--header_text-light: ${setting?.data?.light_mode_styles?.header?.header_text?.value};
--header_icons-light: ${setting?.data?.light_mode_styles?.header?.header_icons?.value};
--header_active-light: ${setting?.data?.light_mode_styles?.header?.header_active?.value};
--header_logo_bg-light: ${setting?.data?.light_mode_styles?.header?.header_logo_background?.value};
--header_bg_color-light: ${setting?.data?.light_mode_styles?.header?.header_background?.value};
--header_button_text-light: ${setting?.data?.light_mode_styles?.header?.header_button_text_icon?.value};
--header_button_bg-light: ${setting?.data?.light_mode_styles?.header?.header_button_background?.value};
--header_dropdown_text-light: ${setting?.data?.light_mode_styles?.header?.header_dropdown_text_icon?.value};
--header_dropdown_bg-light: ${setting?.data?.light_mode_styles?.header?.header_dropdown_background?.value};
--sub_header_bg_color-light: ${setting?.data?.light_mode_styles?.header?.sub_header_background?.value};
--sub_header_text-light: ${setting?.data?.light_mode_styles?.header?.sub_header_text?.value};
--sub_header_text_active-light: ${setting?.data?.light_mode_styles?.header?.sub_header_text_active?.value};
 
--section_icon-light: ${setting?.data?.light_mode_styles?.section?.section_icon?.value};
--section_text-light: ${setting?.data?.light_mode_styles?.section?.section_text?.value};
--section_border-light: ${setting?.data?.light_mode_styles?.section?.section_border?.value};
--section_dropshadow-light: ${setting?.data?.light_mode_styles?.section?.section_dropshadow?.value};
--section_text_2-light: ${setting?.data?.light_mode_styles?.section?.section_text_2?.value};
--section_divider-light: ${setting?.data?.light_mode_styles?.section?.section_divider?.value};
--section_bg-light: ${setting?.data?.light_mode_styles?.section?.section_background?.value};
--section_button_text-light: ${setting?.data?.light_mode_styles?.section?.section_button_text?.value};
--section_icon_active-light: ${setting?.data?.light_mode_styles?.section?.section_icon_active?.value};
--section_heading_text-light: ${setting?.data?.light_mode_styles?.section?.section_heading_text?.value};
--section_heading_text2-light: ${setting?.data?.light_mode_styles?.section?.section_heading_text2?.value};
--section_team_1_color-light: ${setting?.data?.light_mode_styles?.section?.section_team_1_color?.value};
--section_team_2_color-light: ${setting?.data?.light_mode_styles?.section?.section_team_2_color?.value};
--section_row_highlight-light: ${setting?.data?.light_mode_styles?.section?.section_row_highlight?.value};
--section_button_bg-light: ${setting?.data?.light_mode_styles?.section?.section_button_background?.value};
--section_button_text_hover-light: ${setting?.data?.light_mode_styles?.section?.section_button_text_hover?.value};
--section_search_bg-light: ${setting?.data?.light_mode_styles?.section?.section_search_background?.value};
--section_odd_row_bg-light: ${setting?.data?.light_mode_styles?.section?.section_even_row_background?.value};
--section_button_bg_hover-light: ${setting?.data?.light_mode_styles?.section?.section_button_background_hover?.value};

--heading_text-light: ${setting?.data?.light_mode_styles?.headings?.heading_text?.value};
--sub_heading_text-light: ${setting?.data?.light_mode_styles?.headings?.sub_heading_text?.value};
 
--links-light: ${setting?.data?.light_mode_styles?.tags_links?.links?.value};
--ft_text-light: ${setting?.data?.light_mode_styles?.tags_links?.ft_text?.value};
--tag_text-light: ${setting?.data?.light_mode_styles?.tags_links?.tag_text?.value};
--link_hover-light: ${setting?.data?.light_mode_styles?.tags_links?.link_hover?.value};
--ft_bg-light: ${setting?.data?.light_mode_styles?.tags_links?.ft_background?.value};
--tag_bg-light: ${setting?.data?.light_mode_styles?.tags_links?.tag_background?.value};
 
--red_card-light: #D5364E;
--win_button-light: ${setting?.data?.light_mode_styles?.live_center?.win_button_color?.value};
--draw_button-light: ${setting?.data?.light_mode_styles?.live_center?.draw_button?.value};
--live_button-light: ${setting?.data?.light_mode_styles?.live_center?.live_button_color?.value};
--loss_button-light: ${setting?.data?.light_mode_styles?.live_center?.loss_button?.value};
--yellow_card-light: #FFCE00;
--win_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.win_button_text?.value};
--draw_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.draw_button_text?.value};
--live_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.live_button_text?.value};
--loss_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.loss_button_text?.value};
--postponed_button-light: ${setting?.data?.light_mode_styles?.live_center?.postponed_button?.value};
--postponed_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.postponed_button_text?.value};
--match_detail_head_icon-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_icon?.value};
--match_detail_head_text-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_text?.value};
--match_detail_head_text2-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_text2?.value};
--live_center_brand_color-light: ${setting?.data?.light_mode_styles?.live_center?.live_center_brand_color?.value};
--score_ball_by_ball_text-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_text?.value};
--match_detail_head_divider-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_divider?.value};
--match_detail_head_bg-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_background?.value};
--match_detail_head_icon_active-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_icon_active?.value};
--score_ball_by_ball_4th_bg-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_4th_background?.value};
--score_ball_by_ball_6th_bg-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_6th_background?.value};
--match_detail_head_score_bg-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_score_background?.value};
--score_ball_by_ball_score_bg-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_score_background?.value};
  


--radius-dark: ${setting?.data?.dark_mode_styles?.theme?.radius?.value};
--box_shadow-dark: ${setting?.data?.dark_mode_styles?.theme?.box_shadow?.value};
--section_box_shadow-dark: ${setting?.data?.dark_mode_styles?.theme?.section_box_shadow?.value};


--body_text-dark: ${setting?.data?.dark_mode_styles?.body?.body_text?.value};
--body_bg_color-dark: ${setting?.data?.dark_mode_styles?.body?.body_color?.value};
--button_text-dark: ${setting?.data?.dark_mode_styles?.body?.button_text?.value};
--icons_color-dark: ${setting?.data?.dark_mode_styles?.body?.icons_color?.value};
--divider_color-dark: ${setting?.data?.dark_mode_styles?.body?.divider_color?.value};
--button_bg-dark: ${setting?.data?.dark_mode_styles?.body?.button_background?.value};
--button_text_hover-dark: ${setting?.data?.dark_mode_styles?.body?.button_text_hover?.value};
--button_background_hover-dark: ${setting?.data?.dark_mode_styles?.body?.button_background_hover?.value};
--even_row_bg-dark: ${setting?.data?.dark_mode_styles?.body?.even_row_background?.value};
 
--footer_text-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_text?.value};
--footer_icons-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_icons?.value};
--footer_divider-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_divider?.value};
--footer_bg-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_background?.value};
--footer_icon_active-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_icon_active?.value};
--footer_logo_bg-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_logo_background?.value};
 
--header_text-dark: ${setting?.data?.dark_mode_styles?.header?.header_text?.value};
--header_icons-dark: ${setting?.data?.dark_mode_styles?.header?.header_icons?.value};
--header_active-dark: ${setting?.data?.dark_mode_styles?.header?.header_active?.value};
--header_logo_bg-dark: ${setting?.data?.dark_mode_styles?.header?.header_logo_background?.value};
--header_bg_color-dark: ${setting?.data?.dark_mode_styles?.header?.header_background?.value};
--header_button_text-dark: ${setting?.data?.dark_mode_styles?.header?.header_button_text_icon?.value};
--header_button_bg-dark: ${setting?.data?.dark_mode_styles?.header?.header_button_background?.value};
--header_dropdown_text-dark: ${setting?.data?.dark_mode_styles?.header?.header_dropdown_text_icon?.value};
--header_dropdown_bg-dark: ${setting?.data?.dark_mode_styles?.header?.header_dropdown_background?.value};
--sub_header_bg_color-dark: ${setting?.data?.dark_mode_styles?.header?.sub_header_background?.value};
--sub_header_text-dark: ${setting?.data?.dark_mode_styles?.header?.sub_header_text?.value};
--sub_header_text_active-dark: ${setting?.data?.dark_mode_styles?.header?.sub_header_text_active?.value};
 
--section_icon-dark: ${setting?.data?.dark_mode_styles?.section?.section_icon?.value};
--section_text-dark: ${setting?.data?.dark_mode_styles?.section?.section_text?.value};
--section_border-dark: ${setting?.data?.dark_mode_styles?.section?.section_border?.value};
--section_dropshadow-dark: ${setting?.data?.dark_mode_styles?.section?.section_dropshadow?.value};
--section_text_2-dark: ${setting?.data?.dark_mode_styles?.section?.section_text_2?.value};
--section_divider-dark: ${setting?.data?.dark_mode_styles?.section?.section_divider?.value};
--section_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_background?.value};
--section_button_text-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_text?.value};
--section_icon_active-dark: ${setting?.data?.dark_mode_styles?.section?.section_icon_active?.value};
--section_heading_text-dark: ${setting?.data?.dark_mode_styles?.section?.section_heading_text?.value};
--section_heading_text2-dark: ${setting?.data?.dark_mode_styles?.section?.section_heading_text2?.value};
--section_team_1_color-dark: ${setting?.data?.dark_mode_styles?.section?.section_team_1_color?.value};
--section_team_2_color-dark: ${setting?.data?.dark_mode_styles?.section?.section_team_2_color?.value};
--section_row_highdark-dark: ${setting?.data?.dark_mode_styles?.section?.section_row_highdark?.value};
--section_button_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_background?.value};
--section_button_text_hover-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_text_hover?.value};
--section_search_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_search_background?.value};
--section_odd_row_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_even_row_background?.value};
--section_button_bg_hover-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_background_hover?.value};


--heading_text-dark: ${setting?.data?.dark_mode_styles?.headings?.heading_text?.value};
--sub_heading_text-dark: ${setting?.data?.dark_mode_styles?.headings?.sub_heading_text?.value};
 
--links-dark: ${setting?.data?.dark_mode_styles?.tags_links?.links?.value};
--ft_text-dark: ${setting?.data?.dark_mode_styles?.tags_links?.ft_text?.value};
--tag_text-dark: ${setting?.data?.dark_mode_styles?.tags_links?.tag_text?.value};
--link_hover-dark: ${setting?.data?.dark_mode_styles?.tags_links?.link_hover?.value};
--ft_bg-dark: ${setting?.data?.dark_mode_styles?.tags_links?.ft_background?.value};
--tag_bg-dark: ${setting?.data?.dark_mode_styles?.tags_links?.tag_background?.value};
 
--red_card-dark: #D5364E;
--win_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.win_button_color?.value};
--draw_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.draw_button?.value};
--live_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.live_button_color?.value};
--loss_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.loss_button?.value};
--yellow_card-dark: #FFCE00;
--win_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.win_button_text?.value};
--draw_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.draw_button_text?.value};
--live_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.live_button_text?.value};
--loss_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.loss_button_text?.value};
--postponed_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.postponed_button?.value};
--postponed_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.postponed_button_text?.value};
--match_detail_head_icon-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_icon?.value};
--match_detail_head_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_text?.value};
--match_detail_head_text2-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_text2?.value};
--live_center_brand_color-dark: ${setting?.data?.dark_mode_styles?.live_center?.live_center_brand_color?.value};
--score_ball_by_ball_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_text?.value};
--match_detail_head_divider-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_divider?.value};
--match_detail_head_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_background?.value};
--match_detail_head_icon_active-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_icon_active?.value};
--score_ball_by_ball_4th_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_4th_background?.value};
--score_ball_by_ball_6th_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_6th_background?.value};
--match_detail_head_score_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_score_background?.value};
--score_ball_by_ball_score_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_score_background?.value};

}
`;
};
